import { Link } from 'react-router-dom';
import { Box, styled, Typography } from '@mui/material';
import { NavigateBefore } from '@mui/icons-material';

const PREFIX = 'ReturnLink';

const classes = {
  backLink: `${PREFIX}-back-link`,
  backButton: `${PREFIX}-back-button`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.backButton}`]: {
    display: 'flex',
    alignItems: 'center',
    svg: {
      marginLeft: theme.spacing(-0.75),
    },
    p: {
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '157%',
      letterSpacing: '1.5px',
      textTransform: 'uppercase',
      color: theme.palette.buttonColor.main,
    },
  },

  [`& .${classes.backLink}`]: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: theme.palette.buttonColor.main,
  },
}));

interface ReturnLinkProps {
  returnLink: string;
  returnLinkText: string;
}

const ReturnLink = ({ returnLink, returnLinkText }: ReturnLinkProps) => {
  return (
    <StyledBox>
      <Link className={classes.backLink} to={returnLink}>
        <StyledBox className={classes.backButton}>
          <NavigateBefore />
          <Typography>{returnLinkText}</Typography>
        </StyledBox>
      </Link>
    </StyledBox>
  );
};

export default ReturnLink;
